import { useMediaQuery } from "react-responsive";

const useResponsiveInfo = () => {
    const isMobile = useMediaQuery({
        query: "(max-width: 786px)"
    }, undefined, (matches: any) => { if (matches) { }; });

    const isTablet = useMediaQuery({
        query: "(max-width: 1224px)"
    }, undefined, (matches: any) => { if (matches) { }; });

    const isDesktop = useMediaQuery({
        query: "(min-width: 1224px)"
    }, undefined, (matches: any) => { if (matches) { }; });

    return { isMobile, isTablet, isDesktop };
}

export default useResponsiveInfo;